import * as React from "react";
import {
  Drawer,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { getVehicleGroupsByCity } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import { useEffect } from "react";

const groupSchema = z.object({
  name: z.string().min(1, "Name required"),
  totalfreekm: z.coerce.number().optional(),
  kmperhr: z.coerce.number().optional(),
  costperkm: z.coerce.number().optional(),
  costperhr : z.coerce.number().optional(),
  extrakmcost: z.coerce.number().optional(),
  weekdayrent: z.coerce.number().optional(),
  weekendrent: z.coerce.number().optional(),
  type: z.string().nullable(),
  group: z.any(),
});

export default function Addnewpacakgedrawer({
  addNewpackage,
  handleModalClose,
  groupsList,
  selectedRow,
  vehicleProfileData,
  getVehicleProfileRentalPackagesAPI,
  setAddNewPackage,
  isEditMode,
  selectedPackage,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const packageType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.packageType;
  delete packageType?.inverted;
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(groupSchema),
    defaultValues: {
      name: null,
      totalfreekm: null,
      kmperhr: null,
      costperkm: null,
      costperhr : null,
      extrakmcost: null,
      weekdayrent: null,
      weekendrent: null,
      type: null,
      group: vehicleProfileData[0]?.vehicleGroupId,
    },
  });
  

  const handleSaveNewPackage = async (data) => {
    const payload = {
      // id : selectedRow?.id,
      name: data.name,
      totalFreeKm: Number(data.totalfreekm),
      kmPerHr: Number(data.kmperhr),
      costPerKm: Number(data.costperkm),
      costPerHr : Number(data?.costperhr),
      extraKmCost: Number(data.extrakmcost),
      weekdayTariff: Number(data.weekdayrent),
      weekendTariff: Number(data.weekendrent),
      packageType: data.type, // already ID
      groupId: data?.group, // already ID
    };
    try {
      const response = await fetch(`${apiUrl}/api/rentalpackages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("Vehicle package detail Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setAddNewPackage(false);
        await getVehicleProfileRentalPackagesAPI(
          vehicleProfileData[0]?.vehicleGroupId,
        );
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const groupFields = [
    {
      label: "Name",
      value: "name",
      type: "number",
      disabled: false,
    },
    {
      label: "Total Free Km",
      value: "totalfreekm",
      type: "number",
      disabled: false,
    },
    {
      label: "Km / Hr",
      value: "kmperhr",
      type: "number",
      disabled: false,
    },
    {
      label: "Cost / Hr",
      value: "costperkm",
      type: "number",
      disabled: false,
    },
    {
      label: "Extra Km Cost",
      value: "extrakmcost",
      type: "number",
      disabled: false,
    },
    {
      label: "Week Day Rent",
      value: "weekdayrent",
      type: "number",
      disabled: false,
    },
    {
      label: "Week End Rent",
      value: "weekendrent",
      type: "number",
      disabled: false,
    },
    {
      label: "Type",
      value: "type",
      type: "dropdown",
      disabled: false,
      subCategory:
        packageType &&
        Object.entries(packageType).map(([key, value]) => ({
          label: value,
          value: key,
        })),
    },
    {
      label: "Group",
      value: "group",
      type: "text",
      disabled: true,
      subCategory: groupsList.map((item) => ({
        label: item.name,
        value: item?.id,
      })),
    },
  ];

  const renderField = (field) => {
    if (field.type === "autocomplete") {
      return (
        <Controller
          name={field.value}
          control={control}
          render={({ field: rhf }) => (
            <Autocomplete
              freeSolo
              options={field.subCategory || []}
              getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                return option.label || "";
              }}
              value={
                typeof rhf.value === "string"
                  ? rhf.value
                  : field.subCategory?.find(
                      (opt) => opt.value?.id === rhf.value?.id,
                    ) || null
              }
              onChange={(_, value) => {
                if (typeof value === "string") {
                  // typed manually
                  rhf.onChange(value);
                  setValue("code", ""); // clear group code
                } else {
                  // selected from dropdown
                  rhf.onChange(value?.value || "");
                  setValue("code", value?.value?.groupCode || "");
                }
              }}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  rhf.onChange(value);
                  setValue("code", ""); // typing = no group code
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  error={!!errors[field.value]}
                  helperText={errors[field.value]?.message}
                  placeholder="Search or type vehicle number"
                />
              )}
            />
          )}
        />
      );
    }

    if (field?.type === "select" || field?.type === "dropdown") {
      return (
        <Controller
          name={field.value}
          control={control}
          render={({ field: rhf }) => (
            <TextField
              {...rhf}
              select
              fullWidth
              size="small"
              error={!!errors[field.value]}
              helperText={errors[field.value]?.message}
              value={rhf.value ?? ""}
            >
              {field.subCategory?.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      );
    }

    return (
      <Controller
        name={field.value}
        control={control}
        render={({ field: rhf }) => (
          <TextField
            {...rhf}
            type={field.type}
            disabled={field?.disabled}
            size="small"
            fullWidth
            error={!!errors[field.value]}
            helperText={errors[field.value]?.message}
          />
        )}
      />
    );
  };

  return (
    <div>
      <Drawer
        anchor="bottom"
        open={!!addNewpackage}
        onClose={handleModalClose}
        PaperProps={{
          sx: {
            height: "85vh",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            overflow: "hidden",
          },
        }}
      >
        <form onSubmit={handleSubmit(handleSaveNewPackage)}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 p-8">
            {groupFields.map((field, i) => (
              <div key={i}>
                <label className="block mb-1 text-sm font-semibold">
                  {field.label}
                </label>
                {renderField(field)}
              </div>
            ))}
          </div>

          <div className="flex justify-end gap-4 px-8 pb-6">
            {/* Cancel Button */}
            <button
              type="button"
              onClick={handleModalClose}
              className="
      px-6 py-2.5
      rounded-lg
      border border-gray-300
      text-gray-700
      text-sm font-medium
      hover:bg-gray-100
      active:bg-gray-200
      transition
    "
            >
              Cancel
            </button>

            {/* Save Button */}
            <button
              type="submit"
              className="
      px-6 py-2.5
      rounded-lg
      bg-blue-600
      text-white
      text-sm font-semibold
      hover:bg-blue-700
      active:bg-blue-800
      shadow-md
      transition
    "
            >
              Save
            </button>
          </div>
        </form>
      </Drawer>
    </div>
  );
}
